import React, { useEffect } from "react";
import FileInput from "../../../Components/FileInput/FileInput";
import Modal from "../../../Components/Modal/Modal";
import Select from "../../../Components/Select/Select";
import SmallCard from "../../../Components/SmallCard/SmallCard";
import avatar from "../../../images/Avatar_2.svg"
import Input from "../../../Components/Input/Input";
import { mimeTypes } from "../../../constants/constants";
import pdfIcon from "../../../icons/PdfIcon.svg"

export default function AddFlSubjectModal({ flSubject, isOpen, setOpen, flSubjects, ulSubjectId, setUlSubjectId, documentTypes, documentTypeCode, setDocumentTypeCode, documentDate, setDocumentDate, document, setDocument, sig, setSig, onSave }) {


    return (
        <Modal onSave={() => onSave()} title={`Добавление участника (физического лица)`} isOpen={isOpen} setOpen={setOpen}>
            <label>Участник</label>
            <SmallCard
                title={`${flSubject?.Lastname} ${flSubject?.Firstname} ${flSubject?.Middlename}`}
                subtitle={`СНИЛС: ${flSubject?.Snils}`}
                avatar={avatar}
            />
            <Select value={ulSubjectId} onChange={(id) => setUlSubjectId(id)} label="Представитель">
                <option>Нет</option>
                {flSubjects?.map((x) =>
                    <option value={x.Id}>{`${x.Lastname} ${x.Firstname}, Снилс: ${x.Snils}`}</option>

                )}
            </Select>
            {
                !isNaN(ulSubjectId) &&
                <React.Fragment>
                    <label>Документ, подтверждающий полномочия</label>
                    {
                        !document &&
                        <FileInput accept={[mimeTypes.Pdf, mimeTypes.Docx]} onChange={(value) => setDocument(value)}></FileInput>

                    }
                    {
                        document &&
                        <SmallCard onRemove={() => setDocument(null)} avatar={pdfIcon} type="default" title={document.name}></SmallCard>
                    }
                    <label>Электронная подпись</label>
                    {
                        !sig &&
                        <FileInput accept={[mimeTypes.Sig]} onChange={(value) => setSig(value)}></FileInput>

                    }
                    {
                        sig &&
                        <SmallCard onRemove={() => setSig(null)} avatar={pdfIcon} type="default" title={sig.name}></SmallCard>

                    }
                    <Select value={documentTypeCode} onChange={setDocumentTypeCode} label="Тип документа">
                        {documentTypes.map((x) =>
                            <option value={x.code}>{x.name}</option>
                        )}
                    </Select>
                    <Input mask={Date} value={documentDate} onChange={(value) => setDocumentDate(value)} label="Дата выдачи"></Input>
                </React.Fragment>
            }
        </Modal>
    )
}